import React, { useState, useContext } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import scTile from '../tiles/sc_tile';
import TilesCarousel from '../tiles_carousel';
import { AppContext } from '../../context/listingsContext';
import { VIEW_ALL_COMPONENT } from '../top_filters_carousel/constants';
import './index.scss';

export const CarouselContext = React.createContext();

const Title = ({ query }) => (
    <h6 className="m-t-36 m-b-24 tbody-3">
        <I18n k={'search_perseus.subcategory_tiles.title'} params={{ query }}/>
    </h6>
);

const ScTilesCarousel = ({ scTilesData = [] }) => {
    const [collapseCarousel, setCollapseCarousel] = useState(false);

    const {
        query
    } = useContext(AppContext);

    scTilesData.push({ id: VIEW_ALL_COMPONENT });

    const carouselContext = {
        setCollapseCarousel
    };

    return (
        <CarouselContext.Provider value={{ ...carouselContext }}>
            <div className={classNames('sc-carousel m-b-16', { 'collapsed': collapseCarousel })}>
                <Title query={query}/>
                <div className="sc-carousel-wrapper">
                    <TilesCarousel items={scTilesData} TileComponent={scTile}/>
                </div>
            </div>
        </CarouselContext.Provider>
    );
};

ScTilesCarousel.propTypes = {
    scTilesData: object
};

export default ScTilesCarousel;
